import { ShieldCheck, AlertTriangle } from "lucide-react";
import { Breadcrumbs, Reveal, SectionHeader, PrimaryButton } from "../components/common";

const STEPS = [
  ["Quality begins with clear instructions", "Well-defined scope, templates and expectations are the foundation of dependable output."],
  ["Scope and template confirmation", "We confirm the service, format, turnaround and review requirements before work begins."],
  ["File intake", "Files are received through arrangements agreed during scoping. Sensitive files use secure transfer."],
  ["Controlled assignment", "Work is assigned within a controlled workflow appropriate to the project."],
  ["Human review", "Experienced human reviewers check terminology, context, meaning and structure."],
  ["Quality checks", "Formatting, consistency and completeness are verified before delivery."],
  ["Escalation of unclear content", "Uncertain or ambiguous content is flagged and escalated rather than guessed."],
  ["Delivery", "Completed work is delivered in the agreed format and channel."],
  ["Feedback and correction", "Structured feedback is welcomed, and corrections are handled promptly."],
  ["Retention and deletion", "Retention and deletion are handled per the arrangements confirmed with each client."],
  ["Confidentiality commitments", "We work within confidentiality expectations agreed with each client."],
];

export default function Quality() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Quality & Process" }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Quality, Confidentiality & Process</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[52px]">A responsible, human-led approach to documentation quality.</h1>
        <div className="mt-6 flex items-start gap-3 rounded-xl border border-brand-warning/30 bg-[#FBF6EC] p-4 text-[13.5px] text-brand-ink">
          <AlertTriangle className="mt-0.5 h-4.5 w-4.5 shrink-0 text-brand-warning" style={{ width: 18, height: 18 }} />
          <span>Published controls must be reviewed and approved by Primevanta Global before launch. We do not imply certifications or legal compliance that have not been independently established.</span>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-page grid gap-5 md:grid-cols-2">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i % 2}>
              <div className="flex h-full gap-4 rounded-2xl border border-brand-border bg-white p-6">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-alt font-heading text-[14px] font-800 text-brand-primary">{String(i + 1).padStart(2, "0")}</span>
                <div><h2 className="font-heading text-[17px] font-700 text-brand-ink">{t}</h2><p className="mt-1.5 text-[14.5px] leading-relaxed text-brand-muted">{d}</p></div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-brand-evergreen py-16 text-white">
        <div className="container-page flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div className="flex items-start gap-4"><ShieldCheck className="mt-1 h-8 w-8 shrink-0 text-brand-gold" /><div><h2 className="font-heading text-[26px] font-800 md:text-[34px]">Have a security questionnaire?</h2><p className="mt-2 text-white/70">Share your requirements and we will respond with the appropriate detail.</p></div></div>
          <PrimaryButton to="/contact" testid="quality-cta" className="!bg-brand-gold !text-brand-evergreen hover:!bg-[#c2942f]">Send a Questionnaire</PrimaryButton>
        </div>
      </section>
    </>
  );
}
